import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  zh: {
    translation: {
      // ======== General ========
      路線: "路線",
      新增: "新增",
      車輛: "車輛",
      啟用: "啟用",
      名稱: "名稱",
      繁體中文: "繁體中文",
      簡體中文: "簡體中文",
      英文: "英文",
      "general.route": "路線",
      "general.add": "新增",
      "general.vehicle": "車輛",
      "general.operator": "營運商",
      "general.enable": "啟用",
      "general.disable": "禁用",
      "general.name": "名稱",
      "language.tc": "繁體中文",
      "language.sc": "簡體中文",
      "language.en": "英文",
      // ======= LOGIN =======
      "login.wrong_username_password": "密碼錯誤",
      "login.input_username_password": "請輸入用戶名稱及密碼",
      "login.title": "專線小巴實時到站系統 - 網上管理平台",
      "login.username": "用戶名稱",
      "login.password": "密碼",
      "login.login": "登入",
      用戶名稱或密碼錯誤: "密碼錯誤",
      請輸入用戶名稱及密碼: "請輸入用戶名稱及密碼",
      專線小巴實時到站系統網上管理平台: "專線小巴實時到站系統 - 網上管理平台",
      用戶名稱: "用戶名稱",
      密碼: "密碼",
      登入: "登入",
      // ======= MENU =======
      登出: "登出",
      網上管理平台Short: "網上管理平台",
      專線小巴實時到站系統: "專線小巴實時到站系統",
      網上管理平台: "網上管理平台",
      實時監測: "實時監測",
      到站時間表: "到站時間表",
      行車紀錄: "行車紀錄",
      行車軌跡: "行車軌跡",
      行程追溯: "行程追溯",
      營運報表: "營運報表",
      營運總覽: "營運總覽",
      里數報表: "里數報表",
      車輛編配報表: "車輛編配報表",
      行車時間報表: "行車時間報表",
      班次報表: "班次報表",
      服務異常報表: "服務異常報表",
      服務異常總覽: "服務異常總覽",
      偏離路線報表: "偏離路線報表",
      行車時間異常報表: "行車時間異常報表",
      全車隊未能接收數據報表: "全車隊未能接收數據報表",
      同一位置報表: "同一位置報表",
      "超速報表 (只供參考)": "超速報表 (只供參考)",
      營運時間異常報表: "營運時間異常報表",
      營運日子異常報表: "營運日子異常報表",
      系統異常報表: "系統異常報表",
      離線報表: "離線報表",
      管理: "管理",
      電子圍欄: "電子圍欄",
      新增路線: "新增路線",
      路線設定: "路線設定",
      營運商設定: "營運商設定",
      裝置設定: "裝置設定",
      小巴設定: "小巴設定",
      用戶設定: "用戶設定",
      班次設定: "班次設定",
      臨時停用到站預報: "臨時停用到站預報",
      裝置狀態: "裝置狀態",
      // ======= Dashboard ========
      在線: "在線",
      離線: "離線",
      更新時間: "更新時間",
      按車牌: "按車牌",
      按車速: "按車速",
      按上線時間: "按上線時間",
      按營運商分類: "按營運商分類",
      搜尋營運商: "搜尋營運商",
      未有營運商: "未有營運商",
      按路線分類: "按路線分類",
      搜尋路線: "搜尋路線",
      未有路線: "未有路線",
      所有車輛: "所有車輛",
      搜尋車輛: "搜尋車輛",
      "LDD 路線": "LDD 路線",
      "離線小巴－暫無最近路線紀錄。": "離線小巴－暫無最近路線紀錄。",
      顯示所有車輛: "顯示所有車輛",
      HKI: "香港島",
      KLN: "九龍",
      NT: "新界",
      狀態: "狀態",
      暫停載客: "暫停載客",
      服務中: "服務中",
      小時itv: "小時",
      "全日/時段itv": "全日/特定時段",
      "全日/時段": "全日/特定時段",
      "C&W": "中西區",
      Eastern: "東區",
      South: "南區",
      Wch: "灣仔區",
      "Sham Shui Po": "深水埗區",
      "Kowloon City": "九龍城區",
      "Kwun Tong": "觀塘區",
      "Wong Tai Sin": "黃大仙區",
      "Yau Tsim Mong": "油尖旺區",
      Islands: "離島區",
      "Kwai Tsing": "葵青區",
      North: "北區",
      "Sai Kung": "西貢區",
      "Shatin/MOS": "沙田區",
      "Tai Po": "大埔區",
      "Tsuen Wan": "荃灣區",
      "Tuen Mun": "屯門區",
      "Yuen Long": "元朗區",
      "行程時間門檻": "行程時間門檻 (分:秒)",
      密碼到期日: "密碼到期日:",
      "user.username": "用戶名稱",
      "user.password": "密碼",
      totalRow: "總紀錄數目",
      "Order by District": "按地區分類",
      "Search District": "搜尋地區",
      "Please select alarm trigger position": "必須選擇警報觸發位置",
      inRegion: "進入圍欄",
      outRegion: "離開圍欄",
      inOutRegion: "進入及離開圍欄",
      all: "全部",
      "user-manual": "用戶手冊",
      TimeRangeTips: "時間範圍會影響資料載入速度，建議設定不多於一天。",
      "Empty means All": "不選為全選",
      "variants": "走線",
      "fare.insert": "插入分段",
      "fare.delete": "刪除分段",
      "fare.section": "分段",
      "fare.price": "車資",
      "draft.propose_draft": "提交運輸署覆核",
      "draft.save_as_draft": "儲存為草稿",
      "status.accepted": "已批准",
      "status.rejected": "已拒絕",
      "status.draft": "起草中",
      "status.proposed": "已提交運輸署覆核",
      "review.removedHeadwayCount": "已移除班次數目",
      "review.message.hkt.draft": "你有正在草擬的修改，尚未提交運輸署覆核",
      "review.message.hkt.proposed": "正在等待運輸署覆核修改",
      "review.message.td.proposed": "有新修改等待覆核。請在下方批准或拒絕修改",
      "review.message.hkt.accepted.title": "已批准修改",
      "review.message.hkt.accepted": "運輸署已批准修改",
      "review.message.hkt.rejected.title": "已拒絕修改",
      "review.message.hkt.rejected": "運輸署已拒絕修改。原因",
      "status.accepted": "批准",
      "status.rejected": "駁回",
      "status.draft": "起草中",
      "status.proposed": "提交運輸署覆核",
      "review.message.hkt.draft": "你有正在草擬的修改，尚未提交運輸署覆核",
      "review.message.hkt.proposed": "正在等待運輸署線主覆核修改",
      "review.message.td.proposed": "有新修改等待覆核。請在下方批准或駁回修改",
      "review.message.hkt.accepted.title": "已批准修改",
      "review.message.hkt.accepted": "運輸署已批准修改",
      "review.message.hkt.rejected.title": "已駁回修改",
      "review.message.hkt.rejected": "運輸署已駁回修改。原因",
      "review.message.hkt.rejected.attachment": "附件",
      "review.show_original": "顯示原版",
      "review.show_changes": "顯示修改",
      "review.title": "覆核修改",
      "review.accept": "批准修改",
      "review.reject": "拒絕修改",
      "review.upload": "上載附件 (可選)",
      "review.reason": "拒絕原因",
      "review.reason_placeholder": "請在此輸入拒絕原因",
      "changelog.title": "修改紀錄",
      "changelog.version": "版本",
      "changelog.status": "狀態",
      "changelog.reject_reason": "拒絕原因",
      "changelog.attachments": "附件",
      "changelog.proposed_by": "起草用戶",
      "changelog.reviewed_by": "覆核用戶",
      "changelog.history": "紀錄",
      "synclog.SyncToProduction": "Staging (永久) 生效",
      "synclog.SyncToProductionAndSnapshot": "Staging (臨時) 生效",
      "synclog.RecoverFromSnapshot": "Staging (臨時) 到期，還原臨時安排前版本",
      "synclog.noChangelog": "沒有更改紀錄",
      "synclog.scheduled": "已編排",
      "departureArrivalReport.disclaimer": "^ 編定開出時間指以系統上預設班次設定計算的開出時間，即沒有經營辦商因應實際營運情況而調整的預定班次時間",
      "review.reject": "駁回修改",
      "review.upload": "上載附件 (可選)",
      "review.reason": "駁回原因",
      "review.reason_placeholder": "請在此輸入駁回原因",
      "changelog.title": "修改紀錄",
      "changelog.version": "版本",
      "changelog.status": "狀態",
      "changelog.reject_reason": "駁回原因",
      "changelog.attachments": "附件",
      "changelog.proposed_by": "起草用戶",
      "changelog.history": "紀錄",
      "tempDisableEtaIdv.title": "臨時停用到站預報 (個別路線/車站)",
      "tempDisableEtaIdv.add": "新增臨時停用到站預報指示",
      "tempDisableEtaIdv.affectedRoutes": "受影響路線",
      "tempDisableEtaIdv.affectedStops": "受影響車站",
      "tempDisableEtaIdv.affectedRouteStops": "受影響路線-車站",
      "tempDisableEtaIdv.message": "訊息",
      "tempDisableEtaIdv.template": "範本",
      "tempDisableEtaIdv.route": "路線",
      "tempDisableEtaIdv.stop": "車站",
      "tempDisableEtaIdv.routeStop": "路線-車站",
      "routeVariant": "走線",
      "allRouteVariants": "所有走線",
      "routeVariantDescriptionTc": "走線名稱 (繁中)",
      "routeVariantDescriptionSc": "走線名稱 (簡中)",
      "routeVariantDescriptionEn": "走線名稱 (英文)",
      "routeVariantOfficialJourneyTime": "行車時間（分鐘）",
      "extendTemp.title": "延長臨時安排",
      "extendTemp.currentExpiry": "現時臨時安排到期日",
      "extendTemp.newExpiry": "新到期日",
      "extendTemp.createdBy": "延長安排用戶",
      "extendTemp.createDate": "延長安排日期",
      "extendTemp.attachments": "附件",
      "departureArrivalReport.period.am": "上午繁忙時段 (上午7時-9時)",
      "departureArrivalReport.period.interPeak": "中午繁忙時段 (上午9時-下午5時)",
      "departureArrivalReport.period.pm": "黃昏繁忙時段 (下午5時-7時)",
      "departureArrivalReport.period.nonPeak": "非繁忙時段 (其餘時間)",
      "departureArrivalReport.period.all": "全日",
      "departureArrivalReport.numArrival": "班次數目",
      "departureArrivalReport.scheduled": "編定班次",
      "departureArrivalReport.actualArrivalTime": "實際到站時間",
      "departureArrivalReport.scheduledDepartureTime": "^ 編定開出時間",
      "departureArrivalReport.actualDepartureTime": "實際開出時間",
      "departureArrivalReport.departureTimeDiff": "開出時間差距",
      "departureArrivalReport.scheduledHeadway": "編定班距",
      "departureArrivalReport.actualHeadway": "實際班距",
      "departureArrivalReport.headwayDiff": "班距差距",
      "departureArrivalReport.period": "時段",
      "departureArrivalReport.regNumber": "小巴車牌",
      "departureArrivalReport.time": "時段 (小時)",
      "departureArrivalReport.tripCountDiff": "出發班次相差",
      "departureArrivalReport.scheduledTripCount": "編定出發班次",
      "departureArrivalReport.actualTripCount": "實際出發班次",
      "departureArrivalReport.actualHeadwayMin": "實際最短班距 (分鐘)",
      "departureArrivalReport.actualHeadwayMax": "實際最長班距 (分鐘)",
      "departureArrivalReport.actualHeadwayAvg": "實際平均班距 (分鐘)",
      "departureArrivalReport.disclaimer": "^ 編定開出時間指以系統上預設班次設定計算的開出時間，即沒有經營辦商因應實際營運情況而調整的預定班次時間"
    },
  },
  en: {
    translation: {
      // ======== General ========
      "general.route": "Route",
      "general.operator": "Operator",
      "general.vehicle": "Vehicle",
      路線: "Route",
      營運商: "Operator",
      車輛: "Vehicle",
      小巴車牌: "Plate",
      載入中: "Loading",
      間隔: "Interval",
      "general.add": "Add",
      新增: "Add",
      啟用: "Enable",
      名稱: "Name",
      繁體中文: "Traditional Chinese",
      簡體中文: "Simplified Chinese",
      英文: "English",
      "language.tc": "Traditional Chinese",
      "language.sc": "Simplified Chinese",
      "language.en": "English",
      // ======= LOGIN =======
      "login.wrong_username_password": "Username or Password is wrong",
      "login.input_username_password": "Please Input Username and Password",
      "login.title": "Green Minibus Estimated Time of Arrival  - Online Management Platform",
      "login.username": "Username",
      "login.password": "Password",
      "login.login": "Login",
      用戶名稱或密碼錯誤: "Username or Password is wrong",
      請輸入用戶名稱及密碼: "Please Input Username and Password",
      專線小巴實時到站系統網上管理平台:
        "Green Minibus Estimated Time of Arrival  - Online Management Platform",
      用戶名稱: "Username",
      密碼: "Password",
      登入: "Login",
      // ======= MENU =======
      登出: "Logout",
      網上管理平台Short: "OMP - GMB ETA",
      專線小巴實時到站系統: "GMB ETA",
      網上管理平台: "Online Management Platform",
      實時監測: "Current Map",
      到站時間表: "Arrival Timetable",
      行車紀錄: "Trip Records",
      行車軌跡: "Trip Replay",
      行程追溯: "History Trips",
      營運報表: "Operation Reports",
      營運總覽: "Operation Summary",
      里數報表: "Miles Report",
      車輛編配報表: "Vehicle Allocation Report",
      行車時間報表: "Journey Time Report",
      班次報表: "Departure Report",
      服務異常報表: "Exception Reports",
      服務異常總覽: "Exception Summary Report",
      偏離路線報表: "Out-of-Route Report",
      行車時間異常報表: "Journey Time Exception Report",
      全車隊未能接收數據報表: "Full Fleet No Data Report",
      同一位置報表: "Remain at the Same Location Report",
      運行小巴停留同一位置多於一小時報表:
        "Report for GMB in Operation but Remain at the Same Location for More Than One Hour",
      "超速報表 (只供參考)": "Speeding Report (for reference only)",
      營運時間異常報表: "Out of Operating Hours Report",
      營運日子異常報表: "Out of Operating Days Report",
      系統異常報表: "System Exception Report",
      離線報表: "Offline Report",
      管理: "Management",
      電子圍欄: "Geo-fencing",
      新增路線: "Add Route",
      路線設定: "Route Config",
      營運商設定: "Operator Config",
      裝置設定: "Device Config",
      小巴設定: "Vehicle Config",
      用戶設定: "User Config",
      班次設定: "Schedule Config",
      臨時停用到站預報: "Temp Disable ETA",
      裝置狀態: "Device Status",
      // Dashboard
      在線: "Online",
      離線: "Offline",
      更新時間: "Last Update Time",
      按車牌: "Plate",
      按車速: "Speed",
      按上線時間: "Online Time",
      按營運商分類: "By Operator (PSL)",
      搜尋營運商: "Search Operator/PSL",
      未有營運商: "No Operator",
      按路線分類: "By Route",
      搜尋路線: "Search Route",
      未有路線: "No Route",
      所有車輛: "All GMB",
      搜尋車輛: "Search GMB",
      "LDD 路線": "LDD Route",
      顯示所有車輛: "Display All Vehicle",
      HKI: "HKI",
      KLN: "KLN",
      NT: "NT",
      狀態: "Status",
      暫停載客: "Out of Service",
      服務中: "In Service",
      地圖由地政總署提供: "The map is provided by Lands Department",
      正在追蹤: "Tracking",
      退出: "Exit",
      // ===== Reports ======
      地區: "District",
      請選擇: "Please Select",
      分鐘: " mins",
      行車受阻: "Delayed",
      路線方向: "Direction",
      站數: "Station #",
      站名: "Station Name",
      第一班: "First",
      第二班: "Second",
      第三班: "Third",
      暫無: "N/A",
      "沒有相關數據。": "No related data。",
      時間範圍錯誤: "Wrong time range",
      只支援不多於七天的時間範圍:
        "Only support not more than 7 days time range",
      必需填寫: "Required",
      "小巴記錄 - 行車軌跡": "Trip Records - Trip Replay",
      行駛里數: "Miles",
      速度變化: "Change of speed",
      昨天: "Yesterday",
      今天: "Today",
      過去1小時: "past 1 hour",
      過去30分鐘: "past 30 mins",
      過去10分鐘: "past 10 mins",
      "*必填": "*Required",
      搜尋: "Search",
      重設: "Reset",
      由: "From",
      到: "To",
      總行駛里數: "Total Miles",
      總轉數: "Total Trips",
      公里: "KM",
      總出勤時間: "Total Journey Time",
      順序: "Sequence",
      時間: "Time",
      當時路線: "Route (if exist)",
      共: "Total",
      條行程: "trips",
      "小巴記錄 - 行程追溯": "Trip Records - History Trips ",
      上個月: "Last Month",
      今個月: "This Month",
      最少填寫一項: "Required at least one filter",
      全選: "All",
      只顯示已完成的行程: "Only show completed trips",
      每頁數量: "Trips per page",
      全部收起: "Collaspe all",
      全部展開: "Expand all",
      車牌: "Plate",
      開始時間: "Start Time",
      完成時間: "End Time",
      行車時間: "Travelled Time",
      未完成: "Incomplete",
      詳細: "Details",
      匯出: "Export",
      第: "Page",
      頁: "",
      上一頁: "Previous",
      下一頁: "Next",
      偏離路線: "Out-of-route",
      "沒有搜尋結果，請重試。": "No searching result, please retry.",
      "請填寫路線。": "Please select Route.",
      "請選擇營運商／車牌號碼。": "Please select Operator / Plate.",
      "請選擇日期。": "Please select Date.",
      日期: "Date",
      選擇營運商: "Select Operator",
      沒有資料: "No Data",
      車隊全部小巴多於一小時未能接收數據報表:
        "Full Fleet No Data for More Than One Hour Report",
      客運營業證: "PSL",
      區域: "Region",
      線主: "Subject Officer",
      "運行小巴數目(服務詳情表車輛編配數目)":
        "No. of GMB in Operation (# Vehicle allocation in SoS)",
      T1總站名稱: "Terminal Name (T1)",
      T1出發數目: "No. of GMB in Operation (# Vehicle Allocation in SoS) (T1)",
      最快: "Min",
      最慢: "Max",
      平均: "Average",
      首班車出發時間: "First Departure Time",
      尾班車出發時間: "Last Departure Time",
      T2總站名稱: "Terminal Name (T2)",
      T2出發數目: "No. of GMB in Operation (# Vehicle Allocation in SoS) (T2)",
      未有: "N/A",
      循環線: "Circular",
      小時: "h",
      分: "m",
      秒: "s",
      鐘: "",
      行車時間數據: "Journey Time Statistics",
      總行車里數: "Total Miles",
      必填: "Required",
      次序: "Order",
      行程開始時間: "Trip Start Time",
      行程結束時間: "Trip End Time",
      距離: "Distance",
      時間間隔: "Interval",
      速度: "Speed",
      不選擇為全選: "Default: all",
      "上午繁忙時段 (上午7時-9時)": "Morning Peak (7-9AM)",
      "中午繁忙時段 (上午9時-下午5時)": "Inter-Peak (9AM - 5PM)",
      "黃昏繁忙時段 (下午5時-7時)": "Evening Peak (5-7 PM)",
      "非繁忙時段 (其餘時間)": "Off Peak(the rest)",
      全日: "Daily",
      小時itv: "Hourly",
      "全日/時段itv": "Daily/Period",
      "全日/時段": "Daily/Period",
      分區: "District",
      "車輛編配數目 (服務詳情表)": "Vehicle Allocation (SoS)",
      運行小巴數目: "# No. of GMB in Operation",
      全部營運商: "All Operators",
      "車輛編配報表(小時摘要)": "Vehicle Allocation Report (Hourly Summary)",
      "車輛編配報表(每日/特定時段摘要)":
        "Vehicle Allocation Report (Daily/ Specific Time Period Summary)",
      完結時間: "End Time",
      "全日/ 特定時段": "Daily / Time Period",
      總行程時間: "Total Trip Time",
      總站: "Terminus",
      方向: "Direction",
      從站點: "From Station",
      到站點: "To Station",
      所有班次: "Every Departure",
      車站編號: "Station #",
      車站位置: "Station Location",
      "行車時間報表(所有班次摘要)":
        "Journey Time Report (Every Departure Summary)",
      "行車時間表(全日/特定時段摘要)":
        "Journey Time Report (Daily / Specific Time Period Summary)",
      是: "Yes",
      否: "No",
      路線號碼: "Route Code",
      站點: "Station",
      去: "To",
      車站: "Station",
      "總站班次報表(小時摘要)": "Terminus Departure Report (Hourly Summary)",
      "總站班次報表(所有班次摘要)":
        "Terminus Departure Report (Every Departure Summary)",
      "總站班次報表(全日/特定時段摘要)":
        "Terminus Departure Report (Daily/Specific Time Period Summary)",
      "中途站班次報表(小時摘要)":
        "En-Route Stop Departure Report (Hourly Summary)",
      "中途站班次報表(所有班次摘要)":
        "En-route stop Departure Report (Every Departure Summary)",
      "中途站班次報表(全日/特定時段摘要)":
        "En-route stop Departure Report (Daily/Specific Time Period Summary)",
      "時間(小時)": "Time (Hour)",
      編定出發班次: "Scheduled No. of Departures",
      實際出發班次: "Actual No. of Departures",
      出發班次相差: "Difference in No. of Departures ",
      編定班距: "Scheduled Headway",
      "實際最短班距 (分鐘)": "Actual Min. Headway (min)",
      "實際最長班距 (分鐘)": "Actual Max. Headway (min)",
      "實際平均班距 (分鐘)": "Actual Average Headway (min)",
      實際最短班距: "Actual Min. Headway",
      實際最長班距: "Actual Max. Headway",
      實際平均班距: "Actual Average Headway",
      時段: "Time Period",
      "編定班距 (分鐘)": "Scheduled Headway (min)",
      班次數目: "No. of Arrival",
      編定出發時間: "Scheduled Departure Time",
      實際出發時間: "Actual Depature Time",
      差距: "Difference",
      實際班距: "Actual Headway",
      真實到站時間: "Actual Arrival Time",
      運行小巴停留同一位置多於一小時數目:
        "Number of GMB in Operation but Remain at Same Location for more than 1 Hour",
      車隊全部小巴多於一小時無資料次數:
        "Number of Times that No Data can be Received for Full Fleet for more than 1 Hour",
      營業時間異常次數: "Number of Times a GMB Operates Out of Operating Hours",
      營業日子異常次數: "Number of Times a GMB Operates Out of Operating Days",
      偏離路線次數: "Number of Times a GMB Goes Out of Route",
      偏離路線開始時間: "OOR Start Time ",
      偏離路線開始地點: "OOR Start Location",
      偏離路線結束時間: "OOR End Time",
      偏離路線結束地點: "OOR End Location",
      偏離路線時間: "OOR Duration",
      錯誤日期格式: "Wrong Date Format",
      未設定: "N/A",
      "服務詳情表編定行車時間 (分鐘)": "Journey Time in SoS (Min)",
      班次編號: "Departure No.",
      實際行程時間: "Actual Journey Time (Min)",
      "% (如超過20%)": "% (reported if >20%)",
      全日全車隊未能接收數據: "Full fleet no data for whole day",
      地點: "Location",
      開始地點: "Start Location",
      結束時間: "End Time",
      結束地點: "End Location",
      "估計平均速度 (公里/小時)": "Estimated Average Speed (km/h)",
      "有關路段的車限速上限 (公里/小時)":
        "Speed Limit of the road section concerned (km/h)",
      "差距 (公里/小時)": "Difference (km/h)",
      "請選擇營運商。": "Please select operator.",
      編定營運日子: "Scheduled Operating Days",
      在編定營運日子以外運作多於一分鐘的開始時間:
        "Start Time when OOD was recorded for more than 1 min",
      在正常營運日子以外運作的開始位置: "Start Location of OOD",
      在營運日子以外運作的結束日子: "End Time of OOD",
      在正常營運日子以外運作的結束位置: "End Location of OOD",
      全部: "All",
      無路線: "No Route",
      顯示在線車輛: "Show Online Vehicles",
      隱藏在線車輛: "Hide Online Vehicles",
      正常: "Normal",
      "在線/離線": "Online / Offline",
      最後行車紀錄時間: "Last Record Time",
      現在路線: "Current Route",
      新增電子圍欄: "Add Geo-Fence",
      必須畫出電子圍欄: "Must draw the geo-fence",
      成功更新電子圍欄: "Successfully update geo-fence",
      成功新增電子圍欄: "Successfully add geo-fence",
      未能成功更新電子圍欄: "Cannot update geo-fence",
      成功刪除電子圍欄: "Successfully delete geo-fence",
      未能成功刪除電子圍欄: "Cannot delete geo-fence",
      成功新增用戶: "Successfully create user",
      成功更新用戶: "Successfully update user",
      警報觸發位置: "Alarm Tigger Position",
      範圍內: "In Range",
      範圍外: "Out of Range",
      inRegion: "Enter Geofence",
      outRegion: "Exit Geofence",
      inOutRegion: "Enter and Exit Geofence",

      請在地圖上繪製電子圍欄: "Please draw the geo-fence on the map.",
      儲存: "Save",
      刪除: "Delete",
      取消: "Cancel",
      更改: "Update",
      圍欄名稱: "Geo-Fencing Name",
      沒有電子圍欄: "No geo-fence",
      畫出進入範圍: "Draw Entry Area",
      開始繪畫範圍: "Start Drawing Area",
      關閉: "Close",
      確定: "Confirm",
      選擇路線: "Select Route",
      選擇路線及停車站: "Select Route and Stop",
      裝置: "Device",
      新增: "Add",
      編輯: "Edit",
      "Production 版本": "Production",
      "Staging（永久）版本": "Staging (Permanent)",
      "Staging（臨時）版本": "Staging (Temporary)",
      基本資料設定: "Basic Info Config",
      必須填寫路線編號: "Route Code is required",
      必須填寫八達通機路線編號: "LDD Route Code is required",
      必須填寫客運營業證編號: "PSL is required",
      必須填寫起點名稱: "Origin Name is required",
      必須填寫終點名稱: "Destination Name is required",
      路線編號只可以包含數字及英文字母:
        "Route Code should include number and letter ONLY",
      循環線站點編號只可以包含數字:
        "Circular Stop No. should include number ONLY",
      到期日必須在啟用日後: "Expiry Date should be after Effective Date",
      路線已被註冊: "Route Code is used",
      請選擇其他路線編號: "Please select other Route Code",
      必須填寫班次設定: "Schedule is required",
      必須填寫頭班車時間: "First Departure Time is required",
      班距必須為大於零的數字: "Headway must be a number greater than 0",
      班距上限必須為大於零的數字:
        "Max. Headway must be a number greater than 0",
      班距上限必須大於班距: "Max. Headway must be greater than Headway",
      "成功更新路線。即將重新載入此頁面。":
        "Successfully Update Route. Reloading the page",
      "未能成功更新路線, 請稍後再試。":
        "Unable to update route, please try again later.",
      刪除路線: "Delete Route",
      路線編號: "Route Code",
      八達通機路線編號: "LDD Route Code",
      循環線站點編號: "Circular Stop No.",
      客運營業證編號: "PSL",
      "起點(繁體)": "Origin (TC)",
      "起點(簡體)": "Origin (SC)",
      "起點(英文)": "Origin (EN)",
      "終點(繁體)": "Destination (TC)",
      "終點(英文)": "Destination (SC)",
      "終點(簡體)": "Destination (EN)",
      是否循環線: "Circular Route?",
      路線次序: "Route Sequence",
      "行車時間（分鐘）": "Journey Time (min)",
      "路線說明(繁體)": "Route Description (TC)",
      "路線說明(英文)": "Route Description (SC)",
      "路線說明(簡體)": "Route Description (EN)",
      啟用日: "Effective Date",
      到期日: "Expiry Date",
      公眾假期: "Public Holiday",
      適用日子: "Day of the week",
      頭班車時間: "First Departure Time",
      尾班車時間: "Last Departure Time",
      "班距(分鐘)": "Headway (min)",
      "班距上限(分鐘)": "Max. Headway (min)",
      星期一: "Mon",
      星期二: "Tue",
      星期三: "Wed",
      星期四: "Thur",
      星期五: "Fri",
      星期六: "Sat",
      星期日: "Sun",
      一: "M",
      二: "Tu",
      三: "W",
      四: "Th",
      五: "F",
      六: "Sa",
      日: "Su",
      新車站: "New Stop",
      上移: "Move Upward",
      下移: "Move Downward",
      清除: "Clear",
      排序: "Sequence",
      "循環點": "Circular",
      "車站名(中繁)": "Station Name (TC)",
      "車站名(英文)": "Station Name (EN)",
      "車站名(中簡)": "Station Name (SC)",
      "位置(經緯)": "Position (Lat,Lng)",
      範圍: "Area",
      新增班次: "Add Schedule",
      提交: "Submit",
      成功更新營運商: "Successfully update operator",
      "未能更新營運商，請確保客運營業證未被其他營運商使用":
        "Unable to update operator, please make sure the psl is unique.",
      '用";"分隔多個資料(如有)': 'Use ";" to separate mulitple data',
      新增營運商: "Add Operator",
      顯示禁用營運商: "Show Disabled Operators",
      隱藏禁用營運商: "Hide Disabled Operators",
      用逗號分隔: "Use comma to separate",
      "營運商名稱(繁)": "Operator Name (TC)",
      "營運商名稱(簡)": "Operaotr Name (SC)",
      "營運商名稱(英)": "Operator Name (EN)",
      電郵: "Email",
      電話: "Tel",
      聯絡人: "Contact Person",
      "general.enable": "Enable",
      "general.disable": "Disable",
      啟用: "Enable",
      禁用: "Disable",
      搜尋客運營業證: "Search by PSL",
      "搜尋營運商名稱(繁)": "Search by Op. Name (TC)",
      "搜尋營運商名稱(英)": "Search by Op. Name (EN)",
      搜尋車牌: "Search by Plate",
      "搜尋無結果，顯示所有資料": "No result, display all data",
      裝置IMEI: "Device IMEI",
      裝置KEY: "Device KEY",
      系統會自動產生: "System will auto generate KEY",
      "管理 - 裝置": "Device Management",
      新增裝置: "Add Device",
      PD: "PD Comm",
      GPS: "GPS Comm",
      "3G/4G": "Network",
      記憶體: "LDD",
      緩衝: "Buffer",
      最後更新時間: "Last Update Time",
      "管理 - 小巴": "GMB Management",
      共: "Total",
      部小巴: "GMB",
      編號: "ID",
      出勤中: "In Service",
      待命中: "Out of Service",
      新增小巴: "Add GMB",
      更新小巴: "Update GMB",
      用戶: "User",
      "user.username": "Username",
      權限: "Permission",
      重複密碼: "Re-enter Password",
      "user.password": "Password",
      用戶名稱: "Username",
      權限: "Permission",
      重複密碼: "Re-enter Password",
      "user.password": "Password",
      密碼: "Password",
      密碼不相同: "Passowrd is not matched",
      不能更改營運商管理用戶之權限: "Cannot change Operator Admin's Permission",
      "管理 - 用戶": "User Management",
      新增用戶: "Add User",
      用戶帳號: "Username",
      營運商名稱: "Operator Name",
      運輸署: "Transport Department",
      "運輸署(唯讀)": "Transport Department (Read only)",
      "運輸署(路線唯讀)": "Transport Department (Read only - Route)",
      "營運商(唯讀)": "Operator (Read only)",
      不適用: "N/A",
      未能找到相關數據: "No Results, please try again",
      隱藏班次: "Hide Schedule",
      恢復班次: "Resume Schedule",
      必須填寫時間: "Time is Required",
      時間不能早於: "Time cannot set before ",
      時間不能超過: "Time cannot set after ",
      "成功更新班次。": "Successfully Update Schedule",
      "未能更新班次,請稍後再試。": "Cannot Update Schedule, please try again.",
      "請選擇路線/方向/日期及間隔。":
        "Please Select Operator/ Route/ Direction and Date.。",
      "5秒": "5s",
      "30秒": "30s",
      "1分鐘": "1min",
      "5分鐘": "5mins",
      總行車里數: "Total Miles",
      "行程時間門檻 (%)": "Journey Time Threshold (%)",
      "行程時間門檻 (m:s)": "Journey Time Threshold (m:s)",
      "行程時間門檻": "Journey Time Threshold (m:s)",
      車輛編配: "Vehicle Allocation",
      中西區: "Central and Western",
      東區: "Eastern",
      南區: "Southern",
      灣仔區: "Wan Chai",
      深水埗區: "Sham Shui Po",
      九龍城區: "Kowloon City",
      觀塘區: "Kwun Tong",
      黃大仙區: "Wong Tai Sin",
      油尖旺區: "Yau Tsim Mong",
      離島區: "Islands",
      葵青區: "Kwai Tsing",
      北區: "North",
      西貢區: "Sai Kung",
      沙田區: "Sha Tin",
      大埔區: "Tai Po",
      荃灣區: "Tsuen Wan",
      屯門區: "Tuen Mun",
      元朗區: "Yuen Long",
      "Tsuen Wan": "Tsuen Wan",
      "C&W": "Central and Western",
      South: "Southern",
      Wch: "Wan Chai",
      "Shatin/MOS": "Sha Tin",
      Eastern: "Eastern",
      "Sham Shui Po": "Sham Shui Po",
      "Kowloon City": "Kowloon City",
      "Kwun Tong": "Kwun Tong",
      "Wong Tai Sin": "Wong Tai Sin",
      "Yau Tsim Mong": "Yau Tsim Mong",
      Islands: "Islands",
      "Kwai Tsing": "Kwai Tsing",
      North: "North",
      "Sai Kung": "Sai Kung",
      "Tai Po": "Tai Po",
      "Tuen Mun": "Tuen Mun",
      "Yuen Long": "Yuen Long",
      全部匯出: "Export All",
      頁面: "Pages",
      位置: "Coordinates",
      路段: "Street",
      顯示離線小巴: "Show Offline GMB",
      隱藏離線小巴: "Hide Offline GMB",
      搜尋IMEI: "Search by IMEI",
      車資設定: "Fare Config",
      "請選擇營運商/路線/車站。": "Please select Operator & Route & Station.",
      帳戶資料: "Account Information",
      更新密碼: "Update password",
      輸入舊密碼: "Input old password",
      輸入新密碼: "Input new password",
      再次輸入新密碼: "Input new password again",
      更改密碼: "Update",
      舊密碼錯誤: "Old password is wrong",
      "密碼過期，請聯絡系統管理員重設密碼":
        "Password is expired, please contact system administrator to reset password.",
      密碼到期日: "Password Expiry Date:",
      totalRow: "Total Record Count:",
      "Order by District": "Order by District",
      "Search District": "Search District",
      首站: "First Station",
      行程: "Trips",
      "行車時間報表(所有班次摘要)":
        "Journey Time Report (Every Departure Summary)",
      "行車時間報表(全日/特定時段摘要)":
        "Journey Time Report (Daily/ Specific Time Period Summary)",
      編定班次: "Scheduled",
      all: "all",
      "user-manual": "User Manual",
      TimeRangeTips:
        "The time range will affect the loading time. Suggestion: not longer than 1 day.",
      "Empty means All": "Empty means All",
      "variants": "Variants",
      "draft.propose_draft": "Propose Draft to TD",
      "draft.save_as_draft": "Save as Draft",
      "fare.insert": "Insert Section",
      "fare.delete": "Delete Section",
      "fare.section": "Section",
      "fare.price": "Fare",
      "status.accepted": "Accepted",
      "status.rejected": "Rejected",
      "status.draft": "Draft",
      "status.proposed": "Proposed",
      "review.removedHeadwayCount": "Removed Headway Count",
      "review.message.hkt.draft": "You have a pending change not submitted to TD yet",
      "review.message.hkt.proposed": "Change is currently under review by TD",
      "review.message.td.proposed": "Change waiting for approval. Please accept or reject the Change below",
      "review.message.hkt.accepted.title": "Change Accepted",
      "review.message.hkt.accepted": "Change accepted by TD",
      "review.message.hkt.rejected.title": "Change Rejected",
      "review.message.hkt.rejected": "TD has rejected the Change. Reason",
      "review.message.hkt.rejected.attachment": "Attachment",
      "departureArrivalReport.disclaimer": "^ Scheduled departure time means departure time expanded by the headway, i.e. not adjusted by the operator according to the actual operation situation",
      "review.message.hkt.proposed": "Changes for this route is currently under review by TD.",
      "tempDisableEtaIdv.title": "Temporary Disable ETA (Individial Route/Stop)",
      "tempDisableEtaIdv.add": "Add Temporary Disable ETA Entry",
      "tempDisableEtaIdv.affectedRoutes": "Affected Routes",
      "tempDisableEtaIdv.affectedStops": "Affected Stops",
      "tempDisableEtaIdv.affectedRouteStops": "Affected Route-Stop",
      "tempDisableEtaIdv.message": "Message",
      "tempDisableEtaIdv.template": "Template",
      "tempDisableEtaIdv.route": "Route",
      "tempDisableEtaIdv.stop": "Stop",
      "tempDisableEtaIdv.routeStop": "Route-Stop",
      "synclog.SyncToProduction": "Staging (Permanent) effective",
      "synclog.SyncToProductionAndSnapshot": "Staging (Temporary) effective",
      "synclog.RecoverFromSnapshot": "Temporary arrangement ended. Recover content before temporary arrangement",
      "synclog.scheduled": "Scheduled",
      "synclog.noChangelog": "No Changelog",
      "routeVariant": "Route Variant",
      "routeVariantDescriptionTc": "Route Variant Description (TC)",
      "routeVariantDescriptionSc": "Route Variant Description (SC)",
      "routeVariantDescriptionEn": "Route Variant Description (EN)",
      "routeVariantOfficialJourneyTime": "Journey Time (min)",
      "extendTemp.title": "Extend Temporary Arrangement",
      "extendTemp.currentExpiry": "Current Expiry Date",
      "extendTemp.newExpiry": "New Expiry Date",
      "extendTemp.createdBy": "Extend User",
      "extendTemp.createDate": "Extend Date",
      "extendTemp.attachments": "Attachments",
      "allRouteVariants": "All Route Variants",
      "departureArrivalReport.period.am": "Morning Peak (7-9AM)",
      "departureArrivalReport.period.interPeak": "Inter-Peak (9AM - 5PM)",
      "departureArrivalReport.period.pm": "Evening Peak (5-7 PM)",
      "departureArrivalReport.period.nonPeak": "Off Peak(the rest)",
      "departureArrivalReport.period.all": "Daily",
      "departureArrivalReport.numArrival": "No.",
      "departureArrivalReport.actualArrivalTime": "Actual Arrival Time",
      "departureArrivalReport.scheduledDepartureTime": "^ Scheduled Departure Time",
      "departureArrivalReport.actualDepartureTime": "Actual Departure Time",
      "departureArrivalReport.departureTimeDiff": "Departure Time Diff",
      "departureArrivalReport.scheduledHeadway": "Scheduled Headway",
      "departureArrivalReport.actualHeadway": "Actual Headway",
      "departureArrivalReport.headwayDiff": "Headway Diff",
      "departureArrivalReport.regNumber": "License Plate",
      "departureArrivalReport.disclaimer": "^ Scheduled departure time means departure time expanded by the headway, i.e. not adjusted by the operator according to the actual operation situation",
    },
  },
};

export function multiLanguage(i18n, zh, en) {
  if (i18n.language === "en") {
    return en;
  } else {
    return zh;
  }
}

const locale = localStorage.getItem("lang");

i18n.locale = locale;

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // lng: 'en',
    lng: locale || "zh",
    fallbackLng: "zh",
    saveMissing: true,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
